import React from 'react';
import TextField from '@material-ui/core/TextField';

export function FieldsMap(
    fields,
    handleValidation,
    stateFields,
    className) {
    const typeHandler = [];

    for (let field in fields) {
        const currentField = fields[field];
        switch (currentField.type) {
            case 'TextField':
                let fieldLabel = currentField.required ? ("*" + currentField.label) : currentField.label;
                let isError = (stateFields && stateFields[field] && stateFields[field].error /*&& stateFields[field].error.length > 0*/) ? true : false;
                typeHandler.push(
                    <div>
                        <TextField
                            id={currentField.id}
                            error={isError}
                            className={className}
                            key={field}
                            label={fieldLabel}
                            onBlur={e => { handleValidation && handleValidation(e, field, currentField) }}
                            type={currentField.inputType}
                            defaultValue={currentField.defaultValue}
                            helperText={stateFields && stateFields[field] && stateFields[field].error}
                            variant={currentField.variant}
                            InputProps={currentField.type === "text" ? { disableUnderline: true } : undefined}
                        />
                    </div>
                );
                break;
            default:
                break;
        }
    }
    return typeHandler;
}


export function FieldsMapToState(fields) {
    let state = {}
    for (let field in fields) {
        const currentField = fields[field];
        state = {
            ...state,
            [field]: {
                value: currentField.defaultValue || "",
                error: "",
                isValid: currentField.required && !currentField.defaultValue ? false : true //!currentField.required
            }
        }
    }
    return state;
}


export async function HandleValidation(e, fieldName, field, fieldsState, setFieldsState) {
    let value = e.target && e.target.value;
    let required = field.required;
    let error = await field.validateInput(value, required, field.name || field.label, field.inputLength);
    let isValid = false;
    if (!error) isValid = true;
    setFieldsState({ ...fieldsState, [fieldName]: { value, error, isValid } })
}

export function ValidateForm(fieldsToValidate) {
    if (!fieldsToValidate) return true;
    for (let field in fieldsToValidate) {
        if (!fieldsToValidate[field].isValid) return false;
    }
    return true;
}